// extracted by mini-css-extract-plugin
export default {"cursor":"Typewriter_cursor__8RiGj","blinkingText":"Typewriter_blinkingText__3gNOu"};